import { Component, OnInit } from '@angular/core';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { ViewModalComponent } from '../../scaffold/dialogs/view-modal/view-modal.component';

@Component({
    selector: 'app-type-select',
    templateUrl: './type-select.component.html',
    styleUrls: ['./type-select.component.scss'],
    standalone: false
})
export class TypeSelectComponent implements OnInit {
  public data: any;
  _selectedValue: string;
  get selectedValue(): any {
    return this._selectedValue;
  }
  set selectedValue(value) {
    this._selectedValue = value.type;
    if (value.force) {
      this.close();
    }
  }
  available: any[];
  visible: boolean = false;
  constructor(public dialogRef: ScaffoldDialogRef) {}

  show(value: boolean) {
    this.visible = value;
  }
  ngOnInit(): void {
    this.selectedValue = { type: this.data?.scaffoldType, force: false };
  }

  close() {
    if (this.selectedValue) {
      this.dialogRef.close(this.selectedValue);
    }
  }
}
